module.exports = new __parcel__URL__("tropical-fish.797d455e.svg").toString();